export default __webpack_public_path__ + "static/media/phone.6a883fa4.svg";